import React from "react";

export default function NoteIcon24({ width = 24, color = "#14B8A6" }) {
  return (
    <svg
      width={width}
      height={width}
      viewBox={`0 0 ${width} ${width}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_73_1201)">
        <path
          d="M13.4003 2H6.0002C5.4698 2 4.9611 2.2107 4.5861 2.5858C4.211 2.9608 4.0002 3.4695 4.0002 4V20C4.0002 20.5304 4.211 21.0391 4.5861 21.4142C4.9611 21.7893 5.4698 22 6.0002 22H18.0003C18.5307 22 19.0394 21.7893 19.4145 21.4142C19.7895 21.0391 20.0003 20.5304 20.0003 20V12.6M2.0003 6H6.0002M2.0003 10H6.0002M2.0003 14H6.0002M2.0003 18H6.0002M21.3783 5.6260C21.7766 5.2276 21.9004 4.6873 21.9004 4.1240C21.9004 3.5606 21.7766 3.0203 21.3783 2.6220C20.9799 2.2236 20.4396 2.0998 19.8762 2.0998C19.313 2.0998 18.7727 2.2236 18.3743 2.6220L13.3643 7.6340C13.1265 7.8716 12.9525 8.1653 12.8582 8.4880L12.0212 11.358C11.9961 11.444 11.9946 11.5352 12.0169 11.6221C12.0391 11.7089 12.0843 11.7882 12.1477 11.8515C12.2111 11.9149 12.2904 11.9601 12.3772 11.9824C12.464 12.0045 12.5552 12.0031 12.6412 11.978L15.5112 11.141C15.8339 11.0468 16.1276 10.8727 16.3653 10.635L21.3783 5.6260Z"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_73_1201">
          <rect width={width} height={width} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
